import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrl: './authentication.component.scss'
})
export class AuthenticationComponent {
  private oAuthService: OAuthService = inject(OAuthService);
  private router: Router = inject(Router);

  constructor() {
    if (this.oAuthService.hasValidAccessToken()) {
      this.router.navigate(['callback']);
    } else {
      setTimeout(() => {
        this.login();
      }, 2000);
    }
  }

  public login(): void {
    this.oAuthService.initLoginFlow();
  }
}
